import { LOCALSTORAGE_VERSION } from '@/constants';
import Vue from 'vue';
import Vuex from 'vuex';
import organizations from '@/store/organizations';
import page from '@/store/page';
import payment from '@/store/payment';
import project from '@/store/project';
import register from '@/store/register';
import set from '@/store/set';
import task from '@/store/task';
import user from '@/store/user';
import view from '@/store/view';
import demo from '@/store/demo';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

let oldKey = 'chocobo';
let oldData = localStorage.getItem(oldKey);
if (oldData) {
    localStorage.setItem('app', oldData);
    localStorage.removeItem(oldKey);
}

const store = new Vuex.Store({
    state: {
        version: '0.0.0'
    },
    modules: {
        organizations,
        page,
        payment,
        project,
        register,
        set,
        task,
        user,
        view,
        demo
    },
    mutations: {
        setVersion(state, payload) {
            state.version = payload;
        }
    },
    actions: {
        logout() {
            this.dispatch('organizations/reset');
            this.dispatch('payment/reset');
            this.dispatch('project/reset');
            this.dispatch('register/reset');
            this.dispatch('set/reset');
            this.dispatch('user/reset');
            this.dispatch('view/reset');
            this.dispatch('demo/reset');
        },
        setVersion({ commit }, response) {
            commit('setVersion', response);
        }
    },
    plugins: [
        // localStorageにデータを保存する
        createPersistedState({
            key: 'app',
            paths: [
                'page',
                'payment',
                'register',
                'set',
                'task.draft',
                'version',
                'view.organizationId',
                'demo'
            ]
            // storage: window.sessionStorage
        })
    ]
});

function isLtVersion(v1, v2) {
    if (v1 && v2) {
        const arr1 = v1.split('.');
        const arr2 = v2.split('.');
        const max = Math.max(arr1.length, arr2.length);
        for (let i = 0; i < max; i++) {
            arr1[i] = arr1[i] || '0';
            arr2[i] = arr2[i] || '0';
            if (arr1[i] < arr2[i]) {
                return true;
            }
        }
    }
    return false;
}

// localStorageに保存されているバージョンが1.0.0より古かったら
if (isLtVersion(store.state.version, '1.0.0')) {
    // GA・GSCデータサマリーのオーガニックの流入推移のチェック項目に新しい項目を追加する
    const newOrganicChecked = ['impressions', 'clicks', 'ctr', 'rank'];
    const organicChecked = store.state.page.siteSummary.organicChecked
        .concat(newOrganicChecked)
        .filter((x, i, self) => self.indexOf(x) === i); //重複削除
    store.dispatch('page/setStatus', {
        page: 'siteSummary',
        status: { organicChecked: organicChecked }
    });
}

// localStorageのバージョンを更新する
store.dispatch('setVersion', LOCALSTORAGE_VERSION);

export default store;
